import * as React from "react"
import { Input } from "@/components/ui/input"
import { cn, sanitizeAmountStr } from "@/lib/utils"
import type { Currency } from "@/lib/db-types"

type CurrencyInputProps = React.ComponentProps<typeof Input> & {
  currency?: Currency
}

export function CurrencyInput({ currency = 'JPY', onKeyDown, onChange, ...props }: CurrencyInputProps) {
  const symbol = currency === 'USD' ? '$' : '¥'

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (currency === 'JPY' && (e.key === '.' || e.key === 'Decimal')) {
      e.preventDefault()
    }
    onKeyDown?.(e)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = sanitizeAmountStr(e.target.value, currency)
    onChange?.(e)
  }

  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
        {symbol}
      </span>
      <Input
        type="number"
        inputMode={currency === 'USD' ? 'decimal' : 'numeric'}
        step={currency === 'USD' ? '0.01' : '1'}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        {...props}
        className={cn("pl-7", props.className)}
      />
    </div>
  )
}
